module.exports = __webpack_public_path__ + "img/TS-Logo-2-bk.c52adb49.svg";